import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { FacilityInvitationMessagesApi } from '../../../apis/InvitationApi/FacilityInvitationMessagesApi.ts';

interface ResetInvitationMessageVars {
    facilityId: number;
    language: string;
}

export function useResetFacilityInvitationMessage() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    return useMutation<void, AppMedError, ResetInvitationMessageVars>({
        mutationKey: [QueryKeys.facilityInvitationMessages, 'reset'],
        mutationFn: ({ facilityId, language }) =>
            FacilityInvitationMessagesApi.reset(facilityId, language),
        onSuccess: (_data, vars) => {
            queryClient.invalidateQueries({
                queryKey: [QueryKeys.facilityInvitationMessages, vars.facilityId],
            });
            notifications.show({
                color: 'green',
                message: t('invitationMessage.admin.resetDone'),
            });
        },
        onError: (err) => {
            notifications.show({ color: 'red', message: err.message });
        },
    });
}
